import React, { useState } from 'react';
import {MainLayout, InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import portfolios from '../data/portfolios';
import Menu from '../Components/Menu';
import styled from 'styled-components';

const allButtons = ['All', ...new Set(portfolios.map(item => item.category))]

function PortfoliosPage() {
    const [menuItem, setMenuItems] = useState(portfolios);
    const [button, setButtons] = useState(allButtons);

    const filter = () => {

        if(button === 'All'){
            setMenuItems(portfolios);
            return;
        }

        const filteredData = portfolios.filter(item => item.category === button);
        setMenuItems(filteredData);
    }
    return (
        <>
        <title>Works | Foxicode</title>
        <MainLayout>
            <Title title={'Works'} span={'作品'} />
            <TitleText>Selected Works</TitleText>
            <InnerLayout>
                <Menu menuItem={menuItem} />
            </InnerLayout>
        </MainLayout>
        </>
    )
}

const TitleText = styled.h1`
    color: #c46500;
    margin-top: 5rem;

    @media screen and (max-width: 768px){
        font-size: 2.6rem;
        padding-left: 1rem;
    }
`

export default PortfoliosPage
